import React from "react";
import { useI18n } from "../contexts/I18nContext";
import { Sparkles } from "lucide-react";

export default function LaunchBanner() {
  const { t } = useI18n();
  return (
    <div
      className="bg-zinc-900 text-white text-center py-2 px-4 text-xs sm:text-sm font-medium tracking-tight"
      data-testid="launch-banner"
    >
      <span className="inline-flex items-center gap-2">
        <Sparkles className="w-3.5 h-3.5" strokeWidth={2} />
        <span>{t("early_access_chip")} —</span>
        <span className="text-zinc-300">{t("early_access_banner")}</span>
      </span>
    </div>
  );
}
